import { Fragment } from "react";
import { FiChevronRight } from "react-icons/fi";

export type StageStepId = number;

export interface StageStep {
    id: StageStepId;
    label: string;
}

interface Props {
    steps: StageStep[];
    activeStep: StageStepId;
    completedSteps: Set<StageStepId>;
}

export default function StageStepsBar({
    steps,
    activeStep,
}: Props) {
    return (
        <div className="rounded-[14px] border border-white/[0.07] bg-[#212226] px-3 py-2.5 sm:px-4 sm:py-3">
            <div className="ss-stepper-scroll flex items-center gap-0.5 sm:gap-1 overflow-x-auto">
                {steps.map((step, index) => {
                    const isActive = activeStep === step.id;

                    return (
                        <Fragment key={step.id}>
                            <div
                                className={`flex items-center shrink-0 rounded-[10px] px-2.5 py-1.5 sm:px-3 sm:py-2 transition-colors ${
                                    isActive ? "bg-[#1a1b1e]" : ""
                                }`}
                            >
                                <div className="flex items-center gap-2">
                                    <span
                                        className={`w-[22px] h-[22px] rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${
                                            isActive
                                                ? "bg-[#1DA8C6] text-[#08151A]"
                                                : "border border-white/10 text-[#6B6C72]"
                                        }`}
                                    >
                                        {step.id}
                                    </span>
                                    <span
                                        className={`text-[13px] whitespace-nowrap ${
                                            isActive
                                                ? "font-semibold text-[#1DA8C6]"
                                                : "font-medium text-[#6B6C72]"
                                        }`}
                                    >
                                        {step.label}
                                    </span>
                                </div>
                            </div>
                            {index < steps.length - 1 && (
                                <FiChevronRight
                                    className={`w-4 h-4 shrink-0 mx-0.5 sm:mx-1 ${
                                        isActive
                                            ? "ss-stepper-arrow-active text-[#1DA8C6] stroke-[3]"
                                            : "text-[#6B6C72]"
                                    }`}
                                    aria-hidden
                                />
                            )}
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
}
